import { ThemeColor } from 'interface';

export const defaultColors: ThemeColor = {
  white: '#FFFFFF',
  black: '#0C0909',
  dark: '#343a40',
  light: '#F7F7F7',

  institucional: '#00AA13',
  alimentacao: '#DF1683',
  refeicao: '#FF7700',
  auto: '#636569',
  cultura: '#0072CE',
  compras: '#C6007E',
  antecipacao: '#E3CB00',
  parceiro: '#279F00',

  institucionalDark: '#008C15',
  hoverDark: '#0ea349',
  alimentacaoDark: '#D6006D',
  refeicaoDark: '#FF5100 ',
  autoDark: '#54565A',
  culturaDark: '#005AA3 ',
  comprasDark: '#A50064',
  antecipacaoDark: '#C5B000',

  institucionalLight: '#01C117',
  alimentacaoLight: '#FF339B',
  refeicaoLight: '#FF8E2B',
  autoLight: '#818489',
  culturaLight: '#008DFF',
  comprasLight: '#ED0097',
  antecipacaoLight: '#FFE505',

  gray500: '#4A5969',
  gray400: '#6D839A',
  gray300: '#9CAEC1',
  gray200: '#ADBDD0',
  gray100: '#E4E8ED',

  gold: '#988044',
  goldDark: '#6c5928',
  warning: '#ee8040',
  warningDark: '#ca662c',
  info: '#303363',
  infoDark: '#1a1d48',
  cancel: '#e65181',
  cancelDark: '#c13361',
  negative: '#cc2137',
  negativeDark: '#aa1529',
  red: '#A52A2A',
  redDark: '#881B1B',
  yellow: '#FFB800',
  yellowDark: '#D59B04',
  danger: '#E32525',
  dangerDark: '#BD1616',
  success: '#00BC1E',
  successDark: '#008C15',
};
